import React, { useRef, useEffect } from 'react';
import * as Yup from 'yup';
import i18n from 'i18n-js';
import { Grid } from '@material-ui/core';
import { BaseModal } from 'components/UI';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'components/FormFields';
import useStyle from './VerifyPaymentMethodModal.styled';
import * as paymentActions from 'state/modules/payment/actions';
import { FETCH_STATE } from 'constants';

const VerifyPaymentMethodModal = ({ open, paymentId, handleClick }) => {
  const classes = useStyle();
  const formRef = useRef(null);
  const dispatch = useDispatch();

  const fetchUpdatePaymentMethod = useSelector((state) => state.payment?.fetchUpdatePaymentMethod);
  const loading = fetchUpdatePaymentMethod === FETCH_STATE.LOADING;

  const schema = Yup.object().shape({
    amount_1: Yup.number().required(i18n.t('common.required_field')),
    amount_2: Yup.number().required(i18n.t('common.required_field')),
  });

  const handleSave = () => {
    formRef.current.submitForm();
  };

  useEffect(() => {
    if (fetchUpdatePaymentMethod === FETCH_STATE.DONE) {
      handleClick();
    }
  }, [fetchUpdatePaymentMethod, handleClick]);

  const onSubmit = async (params) => {
    const amount1 = parseInt(params.amount_1, 10);
    const amount2 = parseInt(params.amount_2, 10);
    const payload = { amounts: [amount1, amount2] };
    dispatch(paymentActions.fetchVerifyPaymentMethod(paymentId, payload));
  };

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      loading={loading}
      onEnter={handleSave}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      enterButtonLabel={i18n.t('common.verify')}
      title={i18n.t('payments.verify_modal_title')}
      maxWidth={415}
    >
      <Formik innerRef={formRef} initialValues={{}} validationSchema={schema} onSubmit={onSubmit}>
        {({ handleSubmit, values, setFieldValue }) => (
          <Form noValidate onSubmit={handleSubmit} autoComplete="off">
            <p>{i18n.t('payments.verify_modal_description')}</p>
            <Grid
              data-cy="verify-payment-method"
              className={classes.paymentMethods}
              container
              spacing={1}
            >
              <Grid item xs={6}>
                <Field
                  type="text"
                  component={TextField}
                  name="amount_1"
                  label={i18n.t('payments.verify_code_label', { number: 1 })}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  type="text"
                  component={TextField}
                  name="amount_2"
                  label={i18n.t('payments.verify_code_label', { number: 2 })}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

export { VerifyPaymentMethodModal };
